<div class="single-selection-button-list-field__title" *ngIf="title">
  {{ title }}
</div>

<div class="single-selection-button-list-field" *ngIf="options?.length > 0; else noOptionsTemplate">
  <div class="single-selection-button-list-field__options" [class.single-selection-button-list-field__options--extended]="extended">
    <div
      *ngFor="let option of options; let i = index"
      class="single-selection-button-list-field__options__option-container"
      [class.single-selection-button-list-field__options__option-container--extended]="extended"
      [class.single-selection-button-list-field__options__option-container--selected]="selectionStates[i]"
      [class.single-selection-button-list-field__options__option-container--disabled]="disabled"
      (click)="!disabled && selectValue(option[bindValue])"
      data-qa="singleSelection_button"
      tabindex="0"
      (keydown.enter)="selectValue(option[bindValue])"
    >
      <div class="single-selection-button-list-field__options__description-container">
        <span class="single-selection-button-list-field__options__description-container__name">
          {{ option[bindLabel] }}
        </span>
        <span *ngIf="option?.description" class="single-selection-button-list-field__options__description-container__description">
          ({{ option?.description }})
        </span>
      </div>

      <span
        class="single-selection-button-list-field__options__option"
        [ngClass]="{
          'single-selection-button-list-field__options__option--unselected': !selectionStates[i],
          'single-selection-button-list-field__options__option--selected': selectionStates[i]
        }"
      ></span>
    </div>
  </div>
</div>

<ng-template #noOptionsTemplate>
  <div class="single-selection-button-list-field__no-options" data-qa="singleSelection_noOptions" i18n>No options available</div>
</ng-template>
